import _ from "lodash";
import Animator from '../utils/Animator';
import MouseClickSensor from "../utils/MouseClickSensor";

export default class PluginSelection {

    flags = {}

    constructor(designer, {
    } = {}) {

        this.designer = designer;
    }

    install() {

        if (this.designer.mode === "view")
            return;

        this.mouseClickSensor = new MouseClickSensor(e => this.onClick(e), e => this.onMouseDoubleClick(e));

        const dom = this.designer.dom;
        dom.addEventListener("mousedown", this.onMouseDownHandler = this.onMouseDown.bind(this));
        dom.addEventListener("mouseup", this.onMouseUpHandler = this.onMouseUp.bind(this));
        // dom.addEventListener("dblclick", this.onMouseDoubleClickHandler = this.onMouseDoubleClick.bind(this));

        this.unregisterSelectedItemsChangedListener = this.designer.registerSelectedItemsChangedListener(items => {

            this.flags = {};
            items.forEach(c => this.flags[c.id] = true);

            // this.designer.refresh();
            if (this.designer.properties.__FocusOnSelectedItemsChanged) {
                setTimeout(() => {
                    this.designer.dom.focus();
                    this.designer.domEdit.focus();
                }, 1);
            }
        });
    }

    uninstall() {

        if (this.designer.mode === "view")
            return;

        const dom = this.designer.dom;
        dom.removeEventListener("mousedown", this.onMouseDownHandler);
        dom.removeEventListener("mouseup", this.onMouseUpHandler);
        // dom.removeEventListener("dblclick", this.onMouseDoubleClickHandler);
        this.unregisterSelectedItemsChangedListener();
    }

    findNextTop({ x, y }) {

        let diagrams = _.orderBy(this.designer.diagrams, c => c.zIndex);
        diagrams = [this.designer.paper, ...diagrams];

        let intersects = [];
        for (let i = diagrams.length - 1; i >= 0; i--) {
            const model = diagrams[i];
            const founds = model.findIntersects(x, y, 2);

            if (founds instanceof Array && founds.length > 0)
                intersects = [...intersects, ...founds];
            else if (!(founds instanceof Array) && founds)
                intersects.push(founds);
        }

        if (intersects.length === 0)
            return null;
        else if (intersects.length === 1)
            return intersects[0];
        else if (this.designer.selectedItems.length === 0)
            return intersects[0];

        const paperIndex = intersects.indexOf(this.designer.paper);
        if (paperIndex >= 0) {
            intersects.splice(paperIndex, 1);
        }

        for (let i = intersects.length - 1; i >= 0; i--) {
            const item = intersects[i];
            if (this.flags[item.id] && !this.flags[intersects[(i + 1) % intersects.length].id]) {
                return intersects[(i + 1) % intersects.length];
            }
        }

        return intersects[0];

        // const index = intersects.indexOf(this.designer.selectedItems[0]);
        // return intersects[(index + 1) % intersects.length];
    }

    findTop({ x, y }) {

        let diagrams = _.orderBy(this.designer.diagrams, c => c.zIndex);
        diagrams = [this.designer.paper, ...diagrams];

        let intersects = [];
        for (let i = diagrams.length - 1; i >= 0; i--) {
            const model = diagrams[i];
            const founds = model.findIntersects(x, y, 2);

            if (founds instanceof Array && founds.length > 0)
                return founds[0];
            else if (!(founds instanceof Array) && founds)
                return founds;
        }

        return null;
    }

    findAllWithoutPaper({ x, y }) {

        let diagrams = _.orderBy(this.designer.diagrams, c => c.zIndex);
        diagrams = [...diagrams];

        let intersects = [];
        for (let i = diagrams.length - 1; i >= 0; i--) {
            const model = diagrams[i];
            const founds = model.findIntersects(x, y, 2);

            if (founds instanceof Array && founds.length > 0)
                intersects = [...intersects, ...founds];
            else if (!(founds instanceof Array) && founds)
                intersects = [...intersects, founds];
        }

        return intersects;
    }

    onMouseDoubleClick(e) {

        if (this.designer.selectedItems.length === 0)
            return;

        this.designer.selectedItems[0].isEdit = true;
    }

    onClick(e) {

        const rect = this.designer.dom.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;
        let pt = this.designer.screenPointToView({ x, y });

        let model = this.findTop(pt);

        if (!window.event.ctrlKey) {
            this.designer.selectedItems = model;
            return;
        }

        let i = this.designer.selectedItems.indexOf(model);
        if (i < 0)
            this.designer.selectedItems = [...this.designer.selectedItems, model];
        else {

            let items = [... this.designer.selectedItems];
            items.splice(i, 1);
            this.designer.selectedItems = items;
        }
    }

    onMouseDown(e) {
        if (e.button === 0)
            this.mouseClickSensor.down(e);
    }

    onMouseUp(e) {
        if (e.button === 0)
            this.mouseClickSensor.up(e);
    }
}